import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum K1893InvoiceUnfiLineItemKeys {
  itemNumber = 'itemNumber',
  externalItemNumber = 'externalItemNumber',
  caseQtyOrdered = 'caseQtyOrdered',
  externalVendorId = 'externalVendorId',
  mc = 'mc',
  pack = 'pack',
  UoM = 'UoM',
  description = 'description',
  caseCost = 'caseCost',
  discountRate = 'discountRate',
  discountPrice = 'discountPrice',
  lineTotal = 'lineTotal',
}

export const k1893InvoiceUnfiFileDataSchema = yup.object({
  issuer: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  recipient: yup
    .object({
      companyName: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      phoneNumber: yup.string().nullable().optional(),
      emailAddress: yup.string().nullable().optional(),
    })
    .required(),
  invoiceNumber: yup.string().nullable().optional(),
  associatedReferenceNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateDue: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  remittanceInstructions: yup
    .object({
      routingNumber: yup.string().nullable().optional(),
      accountNumber: yup.string().nullable().optional(),
      bankName: yup.string().nullable().optional(),
      bankAddress: yup.string().nullable().optional(),
      beneficiaryName: yup.string().nullable().optional(),
      beneficiaryAddress: yup.string().nullable().optional(),
      paymentLink: yup.string().nullable().optional(),
    })
    .required(),
  items: yup
    .array()
    .of(
      yup
        .object({
          [K1893InvoiceUnfiLineItemKeys.itemNumber]: yup.number().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.externalItemNumber]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.caseQtyOrdered]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.externalVendorId]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.mc]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.pack]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.UoM]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.description]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.caseCost]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.discountRate]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.discountPrice]: yup.string().nullable().optional(),
          [K1893InvoiceUnfiLineItemKeys.lineTotal]: yup.string().nullable().optional(),
        })
        .required(),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  comments: yup.string().nullable().optional(),
})

export type K1893InvoiceUnfiFileData = yup.InferType<typeof k1893InvoiceUnfiFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<K1893InvoiceUnfiFileData>

export const k1893InvoiceUnfiFileMappings: RequiredFileData = {
  issuer: {
    companyName: '86e1fdd3-facd-4c3f-8f47-1d2d7cce82fe',
    addressLine1: '2b6ac7b0-4f73-4f03-963a-53d95cc5ec9a',
    phoneNumber: 'f3f32231-a737-49dc-a802-0e8171b51946',
    emailAddress: '4da3a514-6f13-4809-894d-d24abe9b967c',
  },
  recipient: {
    companyName: 'fabc599f-ba6e-4927-9414-ab9b74507f29',
    addressLine1: '2e6fca9f-75d1-4649-9e53-ea57426f4c04',
    phoneNumber: '8e3cd026-e7e5-4b40-a652-1c960a042184',
    emailAddress: '8b208f73-add8-4911-b1cb-2f2ac169afe8',
  },
  invoiceNumber: 'f9d4cf36-1b15-4241-a720-e676dd2ef419',
  associatedReferenceNumber: '117b0667-2658-4eae-b81c-cebdefd62cf4',
  dateIssued: '9e401713-9844-482e-a773-9b70c14723c7',
  dateDue: '9c7c5305-7cb7-42c1-8186-dab857835131',
  paymentTerms: 'f7e95d97-17ad-4512-9796-a69c99f5f065',
  freightTerms: '1d8221f4-4e44-49cb-b0b7-210bb8117ab8',
  remittanceInstructions: {
    routingNumber: '53ff7da1-dfe9-4d73-ab33-d0246335c49f',
    accountNumber: 'e9878ca4-8111-4752-87b6-8a0ece9d4e65',
    bankName: '28482319-5d3e-4670-8c17-5f10c097c246',
    bankAddress: 'd7276e94-78ff-4301-b0d5-791fc3c17e77',
    beneficiaryName: '3daf46f9-cecb-44ee-a0a2-7a2b1c42ff6c',
    beneficiaryAddress: '71969727-e28e-4db4-9119-75a966d46196',
    paymentLink: '2b066635-a017-49ae-9639-224eb65fa04d',
  },
  items: [
    {
      itemNumber: null,
      externalItemNumber: '711fc5af-7dc3-4474-a17d-81ce9f45d927',
      caseQtyOrdered: '77c72ffe-e754-4a13-beb3-2829c1759438',
      externalVendorId: 'bcab159f-23d6-4a6e-bca0-4609d4757b55',
      mc: '55dc1b47-773e-4528-ae77-0219d140d57e',
      pack: '01b05f8f-e64a-4091-bcf6-587932593904',
      UoM: '1d16551d-6919-493e-9e67-6990fb77fd61',
      description: 'b350b989-e25a-4338-872d-2a6c61b10020',
      caseCost: 'f1864756-2661-4744-be25-aed46808fe65',
      discountRate: 'f8a0b5d1-4c2e-4a3b-9c7f-0d6e5f1b2c3d',
      discountPrice: null,
      lineTotal: null,
    },
  ],
  agreement: '48072d31-0bac-48c6-97db-28687803b952',
  comments: '69a6c4a3-5d2d-4601-a3f9-d5d12f672b3d',
}
